export enum LoginFormControls {
    EMAIL = 'email',
    PASSWORD = 'password'
}
